import { errorConfig } from "@/requestErrorConfig";
import type { RequestConfig } from "@umijs/max";
import { SiteType } from "./global";

// 从环境变量或运行时配置获取基础URL
// 兼容全局 window 上自定义属性的类型声明
// @ts-ignore
const API_BASE_URL = window.API_URL || "/api"; // 使用空字符串，让请求走代理配置
console.log("API Base URL:", API_BASE_URL);
const siteHeaderInterceptor = (url: string, options: any) => {
  const lsSite = localStorage.getItem("currentSite");
  const currentSite = lsSite ?? null;
  if (
    currentSite &&
    !url.startsWith("http") &&
    currentSite !== SiteType.ALL.toString()
  ) {
    options.headers = {
      ...options.headers,
      "X-Ogl-Account-Id": currentSite,
    };
  }
  return { url, options };
};

export const requestConfig: RequestConfig = {
  timeout: 30000,
  baseURL: API_BASE_URL,
  requestInterceptors: [
    siteHeaderInterceptor,
    ...(errorConfig.requestInterceptors as any[]),
  ],
  responseInterceptors: errorConfig.responseInterceptors as any[],
  errorConfig: errorConfig.errorConfig,
};
